// extracted by mini-css-extract-plugin
export default {"loader_light":"app-loader_loader_light__xjWgK","loader_dark":"app-loader_loader_dark__0tA7d"};